var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.334 11.833C15.0473 11.833 14.0007 12.8797 14.0007 14.1677C14.0007 15.4543 15.0473 16.4997 16.334 16.4997C17.6207 16.4997 18.6673 15.4543 18.6673 14.1677C18.6673 12.8797 17.6207 11.833 16.334 11.833ZM16.334 18.4997C13.9447 18.4997 12.0007 16.557 12.0007 14.1677C12.0007 11.777 13.9447 9.83301 16.334 9.83301C18.7233 9.83301 20.6673 11.777 20.6673 14.1677C20.6673 16.557 18.7233 18.4997 16.334 18.4997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_892_11178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 23,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 3.1665H27.3327V29.1665H5.33334V3.1665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_892_11178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3327 5.1665C11.37 5.1665 7.33267 9.2425 7.33267 14.2505C7.33267 20.6225 14.8313 26.8305 16.3327 27.1612C17.834 26.8292 25.3327 20.6212 25.3327 14.2505C25.3327 9.2425 21.2953 5.1665 16.3327 5.1665ZM16.3327 29.1665C13.9407 29.1665 5.33267 21.7638 5.33267 14.2505C5.33267 8.1385 10.2673 3.1665 16.3327 3.1665C22.398 3.1665 27.3327 8.1385 27.3327 14.2505C27.3327 21.7638 18.7247 29.1665 16.3327 29.1665Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLocation);
export default __webpack_public_path__ + "static/media/dashboard-location.576965d8ffb8a70c26515d13ebd1da2e.svg";
export { ForwardRef as ReactComponent };